module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-policy"
  }, [_c('h2', [_vm._v("\n        Privacy Policy\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        TBA.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37bb4d46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/policies/PrivacyPolicy.vue
// module id = 1641
// module chunks = 0